import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-voorkoming',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-voorkoming.component.html',
  styleUrl: './tekst-voorkoming.component.scss',
})
export class TekstVoorkomingComponent {}
